'use client';

import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { ChainUtils } from '@morpho-org/blue-sdk';
import { Avatar, ClipboardButton } from '@morpho-org/ui-v6/client';
import { Button } from '@repo/ui';
import { ArrowDiagonalUp } from '@repo/ui/icons';
import { abbreviateAddress } from '@repo/utils';
import { ButtonLink } from '@/components/common/ButtonLink';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/common/overlays';
interface TokenWithHoverCardProps {
  asset: InterfaceToken;
}
const TokenWithHoverCard = t0 => {
  const $ = _c(39);
  const {
    asset
  } = t0;
  let t1;
  if ($[0] !== asset.address || $[1] !== asset.chain.id) {
    t1 = ChainUtils.getExplorerAddressUrl(asset.chain.id, asset.address);
    $[0] = asset.address;
    $[1] = asset.chain.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const explorerUrl = t1;
  let t2;
  if ($[3] !== asset.address) {
    t2 = abbreviateAddress(asset.address);
    $[3] = asset.address;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const formattedAddress = t2;
  let t3;
  if ($[5] !== asset.logoURI) {
    t3 = <Avatar src={asset.logoURI} />;
    $[5] = asset.logoURI;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== asset.symbol || $[8] !== t3) {
    t4 = <HoverCardTrigger asChild={true}><Button className="cursor-default py-[3px] pr-[10px] pl-[5px]" variant="ghost">{t3}{asset.symbol}</Button></HoverCardTrigger>;
    $[7] = asset.symbol;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      minWidth: "275px",
      maxWidth: "315px"
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-2xs" style={{
      lineHeight: "normal"
    }}>Token</span>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== asset.logoURI) {
    t7 = <Avatar src={asset.logoURI} size="small" />;
    $[12] = asset.logoURI;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      lineHeight: "normal"
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== asset.symbol) {
    t9 = <span className="text-2xs" style={t8}>{asset.symbol}</span>;
    $[15] = asset.symbol;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <div className="flex items-center justify-between p-[10px_12px]">{t6}<div className="flex items-center gap-[2px]">{t7}{t9}</div></div>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-2xs" style={{
      lineHeight: "normal"
    }}>Address</span>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      lineHeight: "normal"
    };
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== formattedAddress) {
    t13 = <span className="text-2xs" style={t12}>{formattedAddress}</span>;
    $[22] = formattedAddress;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== asset.address) {
    t14 = <ClipboardButton toCopy={asset.address} toastMessage="Token address copied to clipboard." tooltipMessage="Copy Token Address." size="sm" />;
    $[24] = asset.address;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      variant: "ghost",
      size: "sm",
      iconAlone: <ArrowDiagonalUp />,
      iconRight: undefined
    };
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== explorerUrl) {
    t16 = <ButtonLink href={explorerUrl} mode="external" buttonProps={t15} />;
    $[27] = explorerUrl;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t13 || $[30] !== t14 || $[31] !== t16) {
    t17 = <div className="flex items-center justify-between p-[10px_12px]">{t11}<div className="gap-2xs flex items-center">{t13}{t14}{t16}</div></div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t10 || $[34] !== t17) {
    t18 = <HoverCardContent style={t5} side="top" sideOffset={8} onClick={_temp}><div className="flex flex-col p-[12px_0px]">{t10}{t17}</div></HoverCardContent>;
    $[33] = t10;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t18 || $[37] !== t4) {
    t19 = <HoverCard openDelay={200} closeDelay={100}>{t4}{t18}</HoverCard>;
    $[36] = t18;
    $[37] = t4;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  return t19;
};
export default TokenWithHoverCard;
function _temp(e) {
  return e.stopPropagation();
}